import './../products/products.scss'
import { DollarOutlined, PlusOutlined, UserOutlined, CalendarOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import CountUp from 'react-countup';
import { Button, Space, Popover, Popconfirm, Tag, Modal, Input, Pagination } from 'antd';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import FormDepenses from './FormDepenses';
import config from '../../config';
import moment from 'moment';
import Depenses from './Depenses';
import canSeeFinance from '../../utils/canSeeFinance';
import usePermissions from '../../hooks/usePermissions';
import {
  NdoePage, NdoePageHeader, NdoeToolbar, NdoeActionButton,
  NdoeResponsiveTable, NdoeDataCard, NdoeStats, NdoeStatCard,
} from '../../components/ndoe';

const DepensesAll = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [open, setOpen] = useState(false);
    const [openDetail, setOpenDetail] = useState(false);
    const [dateData, setDateData] = useState('');
    const user = useSelector((state) => state.user?.currentUser);
    const { can } = usePermissions();
    // Montants visibles avec la permission depenses.voir_montants (la secrétaire
    // l'a via le seed) ; canSeeFinance = repli instantané pour l'admin.
    const canVoirMontants = canSeeFinance(user) || can('depenses.voir_montants');
    const [recent, setRecent] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 15,
    });
    const [totalItems, setTotalItems] = useState('');

      const fetchData = async (page = currentPage, size = pageSize) => {
        try {
          const { data } = await axios.get(`${DOMAIN}/api/depenses?page=${page}&pageSize=${size}`);
          setData(data.data);
          setTotalItems(data.total)
          setLoading(false)
        }catch (error) {
          console.log(error);
          setLoading(false)
        }
      };

      const handleDelete = async (id) => {
      try {
          await axios.delete(`${DOMAIN}/api/depenses/${id}`);
          toast.success('Dépense supprimée');
          fetchData(currentPage, pageSize);   // refetch au lieu de recharger toute la page
        } catch (err) {
          toast.error(`Erreur: ${err.message}`);
        }
      };

      const columns = [
        { title: '#',
          dataIndex: 'id',
          key: 'id',
          render: (text, record, index) => {
            const size = pagination.pageSize || 15;
            const pageIndex = pagination.current || 1;
            return (pageIndex - 1) * size + index + 1;
          }
        },
       {
            title: 'Jour',
            dataIndex: 'jour',
            key: 'jour',
            sorter: (a, b) => a.jour - b.jour,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => (
              <Tag color="blue" icon={<CalendarOutlined />}>
                {record.jour}
              </Tag>
            ),
          },
          {
            title: 'Date',
            dataIndex: 'date_depense',
            key: 'date',
            sorter: (a, b) => moment(a.date_depense) - moment(b.date_depense),
            sortDirections: ['descend', 'ascend'],
            render: (text) => (
              <Tag icon={<CalendarOutlined />} color="blue">
                {moment(text).format('DD-MM-yyyy')}
              </Tag>
            ),
          },
           {
            title: '# Dollars',
            dataIndex: 'montant_total_dollars',
            key: 'montant_total_dollars',
            sorter: (a, b) => a.montant_total_dollars - b.montant_total_dollars,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => (
              <Tag color={record.montant_total_dollars !== null ? 'green' : 'red'} icon={<DollarOutlined />}>
                {record.montant_total_dollars ? record.montant_total_dollars + ' $' : '0' + ' $'}
              </Tag>
            ),
          },
           {
            title: '# Francs',
            dataIndex: 'montant_total_francs',
            key: 'montant_total_francs',
            sorter: (a, b) => a.montant_total_francs - b.montant_total_francs,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => (
              <Tag color={record.montant_total_francs !== null ? 'green' : 'red'}>
                {record.montant_total_francs !== null ? record.montant_total_francs + ' fc' : '0' + ' fc'}
              </Tag>
            ),
          },
          {
            title: '# Total',
            dataIndex: 'montant_total_combine',
            key: 'montant_total_combine',
            sorter: (a, b) => a.montant_total_combine - b.montant_total_combine,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => (
              <Tag color={record.montant_total_combine !== null ? 'green' : 'red'} icon={<DollarOutlined />}>
                {record.montant_total_combine ? record.montant_total_combine + ' $' : '0' + ' $'}
              </Tag>
            ),
          },
          {
            title: 'Crée par',
            dataIndex: 'createur',
            key: 'createur',
            render: (text) => (
              <Tag color="blue" icon={<UserOutlined />}>
                {text}
              </Tag>
            ),
          },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (

              <Space size="middle">
                <>
                    <Popover title="Voir les détails" trigger="hover">
                        <Link onClick={() => handleOkDetail(record.date_depense)}>
                            <Button icon={<EyeOutlined />} style={{ color: 'blue' }} />
                        </Link>
                    </Popover>
                    {user?.role === 'admin' &&
                    <Popover title="Supprimer" trigger="hover">
                    <Popconfirm
                        title="Êtes-vous sûr de vouloir supprimer?"
                        onConfirm={() => handleDelete(record.id_depense)}
                        okText="Oui"
                        cancelText="Non"
                    >
                        <Button icon={<DeleteOutlined />} style={{ color: 'red' }} />
                    </Popconfirm>
                    </Popover>  }
                </>
              </Space>
            ),
          },
      ];

      const handleTableChange = (paginationArg) => {
        // Pas de fetchData ici : le useEffect [currentPage, pageSize] s'en charge.
        setCurrentPage(paginationArg.current);
        setPageSize(paginationArg.pageSize);
        setPagination({
          current: paginationArg.current,
          pageSize: paginationArg.pageSize,
        });
      };

      useEffect(() => {
        fetchData(currentPage, pageSize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [currentPage, pageSize]);

      useEffect(() => {
        const fetchRapport = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/depenses/depenseRapportChiffre`);
            setRecent(data);
            setLoading(false)
          } catch (error) {
            console.log(error);
          }
        };
        fetchRapport();
      }, [DOMAIN]);


    const handleOk = async (e) => {
      setOpen(true)
    };

    const handleOkDetail = async (e) => {
      setOpenDetail(true)
      setDateData(e)
    };

  const filteredData = data?.filter((item) =>
    item.jour?.toLowerCase().includes(searchValue.toLowerCase())
  );

  const financeColumnKeys = ['montant_total_dollars', 'montant_total_francs', 'montant_total_combine'];
  const displayedColumns = canVoirMontants
    ? columns
    : columns.filter((col) => !financeColumnKeys.includes(col.key));

  // Carte mobile — les montants (métriques finance) sont DERRIÈRE canVoirMontants.
  const renderDepenseCard = (record) => {
    const financeMetrics = canVoirMontants
      ? [
          { value: `${record.montant_total_dollars ?? 0} $`, label: 'Dollars' },
          { value: `${record.montant_total_francs ?? 0} fc`, label: 'Francs' },
          { value: `${record.montant_total_combine ?? 0} $`, label: 'Total' },
        ]
      : [];

    const actions = [
      <NdoeActionButton
        key="v"
        size="sm"
        variant="ink"
        icon={<EyeOutlined />}
        onClick={() => handleOkDetail(record.date_depense)}
      >
        Détails
      </NdoeActionButton>,
      user?.role === 'admin' && (
        <Popconfirm
          key="d"
          title="Êtes-vous sûr de vouloir supprimer?"
          onConfirm={() => handleDelete(record.id_depense)}
          okText="Oui"
          cancelText="Non"
        >
          <NdoeActionButton size="sm" variant="danger" icon={<DeleteOutlined />}>Suppr.</NdoeActionButton>
        </Popconfirm>
      ),
    ].filter(Boolean);

    return (
      <NdoeDataCard
        title={record.date_depense ? moment(record.date_depense).format('DD-MM-YYYY') : (record.jour || '—')}
        subtitle={`Jour ${record.jour ?? '—'} · ${record.createur ?? '—'}`}
        metrics={financeMetrics}
        actions={actions}
        onClick={() => handleOkDetail(record.date_depense)}
      />
    );
  };

  return (
    <NdoePage>
      <NdoePageHeader
        eyebrow="Finance"
        title="Liste des dépenses"
        subtitle="Gérez vos dépenses"
        actions={
          <NdoeActionButton variant="primary" icon={<PlusOutlined />} onClick={handleOk}>
            Nouvelle dépense
          </NdoeActionButton>
        }
      />

      <NdoeStats>
        {recent[0]?.date_plus_ancienne && (
          <NdoeStatCard
            label="Période"
            value={`${moment(recent[0]?.date_plus_ancienne).format('DD-MM-YYYY')} → ${moment(recent[0]?.date_plus_recente).format('DD-MM-YYYY')}`}
          />
        )}
        {canVoirMontants && (
          <NdoeStatCard gold label="Montant total" value={<><CountUp end={recent[0]?.total_depense || 0} /> $</>} />
        )}
      </NdoeStats>

      <NdoeToolbar
        search={
          <Input.Search
            type="search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Rechercher (jour)…"
            allowClear
          />
        }
      />

      <NdoeResponsiveTable
        data={filteredData}
        columns={displayedColumns}
        rowKey="id_depense"
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: Number(totalItems) || 0,
        }}
        onChange={handleTableChange}
        renderCard={renderDepenseCard}
        empty={{ icon: '💸', title: 'Aucune dépense', text: 'Ajustez la recherche.' }}
        mobilePager={
          <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={Number(totalItems) || 0}
              showSizeChanger={false}
              onChange={(p, s) => handleTableChange({ current: p, pageSize: s })}
            />
          </div>
        }
      />

      {/* Modales */}
      <Modal
        centered
        title='Ajouter une dépense'
        open={open}
        onCancel={() => setOpen(false)}
        width={650}
        footer={[]}
      >
        <FormDepenses
          fetchData={() => fetchData(currentPage, pageSize)}
          closeModal={() => setOpen(false)}
        />
      </Modal>

      <Modal
        centered
        title=''
        open={openDetail}
        onCancel={() => setOpenDetail(false)}
        width={1000}
        footer={[]}
      >
        <Depenses dateId={dateData} fetchDatas={fetchData} />
      </Modal>
    </NdoePage>
  )
}

export default DepensesAll
